import angular from 'angular';
import { ApplicationsController } from './applications.controller.js';
import { ApplicationController } from './application.controller';
import { ApplicationsService } from './applications.service';



angular
  .module('parameters.applications', [])
  .controller('ApplicationsController', ApplicationsController)
  .controller('ApplicationController', ApplicationController)
  .factory('ApplicationsFactory', ApplicationsService.ApplicationsFactory)
;
